import React from 'react';
import { Trans } from '@lingui/macro';

// const tickets = [
//   {
//     name: 'Emerald Magical Pass',
//     price: '64.95',
//     tier: <Trans>Tier 2</Trans>,
//     color: '#046A38',
//     gradient: 'rgba(4, 106, 56, 0.4)',
//     features: [
//       <Trans>1x Access to Amaré Music Festival</Trans>,
//       <Trans>Magical experience</Trans>
//     ],
//     showSeparator: true,
//   },
//   {
//     name: 'Sapphire Luxury Pass',
//     price: '99.99',
//     tier: <Trans>Tier 2</Trans>,
//     color: '#0F52BA',
//     gradient: 'rgba(15, 82, 186, 0.4)',
//     features: [
//       <Trans>1x Access to Amaré Music Festival</Trans>,
//       <Trans>VIP covered lounge area</Trans>,
//       <Trans>Private bar access</Trans>,
//       <Trans>VIP Toilets</Trans>,
//     ],
//     showSeparator: true,
//   },
//   {
//     name: 'Ruby Prestige Package',
//     price: '109.99',
//     totalPrice: '439.99',
//     tier: <Trans>Tier 2</Trans>,
//     color: '#9B111E',
//     gradient: 'rgba(155, 17, 30, 0.4)',
//     features: [
//       <Trans>4x Access to Festival</Trans>,
//       <Trans>4x VIP lounge access</Trans>,
//       <Trans>Reserved VIP Table</Trans>,
//       <Trans>Private bar access</Trans>,
//       <Trans>VIP Toilets</Trans>,
//     ],
//     people: <Trans>Package for 4 people</Trans>,
//   },
// ];

function Tickets() {
  return (
    <section className="tickets-modern" id="tickets">
      <video 
        className="tickets-video-bg" 
        autoPlay 
        muted 
        loop 
        playsInline
      >
        <source src="/videos/home-video.mp4" type="video/mp4" />
      </video>
      <div className="bg-overlay bg-gradient-secondary" style={{ opacity: 0.8 }}></div>
      <div className="tickets-particles">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="ticket-particle" style={{ '--delay': `${Math.random() * 10}s`, '--x': `${Math.random() * 100}%`, '--duration': `${10 + Math.random() * 10}s` }}></div>
        ))}
      </div>
      <div className="container py-5">
        <div className="text-center mb-5">
          <h2 className="tickets-heading"><Trans>TICKETS</Trans></h2>
          <p className="tickets-subheading">
            {/* <Trans>Get your ticket now and be part of an unforgettable experience!</Trans> */}
            <Trans>See you next year!</Trans>
          </p>
        </div>
        {/* <div className="row g-4 justify-content-center">
          {tickets.map((ticket, index) => (
            <div className="col-lg-4 col-md-6 col-12" key={index}>
              <div 
                className="ticket-modern-card"
                style={{ '--accent': ticket.color }}
              >
                <div className="ticket-card-glow"></div>
                <div className="ticket-card-content">
                  <div 
                    className="ticket-card-gradient"
                  >
                    <div className="ticket-tier-badge" style={{ color: ticket.color, background: 'rgba(255,255,255,0.25)' }}>{ticket.tier}</div>
                    <div className="ticket-icon" style={{ color: ticket.color }}>
                      <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                        <path d="M22 10V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v4c1.1 0 2 .9 2 2s-.9 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54z"/>
                      </svg>
                    </div>
                    <h3 className="ticket-name">
                      {ticket.name}
                    </h3>
                    <div className="ticket-price-wrapper">
                      {ticket.totalPrice && (
                        <span className="ticket-per-person"><Trans>per person</Trans></span>
                      )}
                      <div className="ticket-price-inline">
                        <span className="ticket-currency">$</span>
                        <span className="ticket-amount">{ticket.price}</span>
                      </div>
                    </div>
                    {ticket.totalPrice && (
                      <div className="ticket-total-price">${ticket.totalPrice} <Trans>total for 4</Trans></div>
                    )}
                    {ticket.people && (
                      <div className="ticket-people-badge">{ticket.people}</div>
                    )}
                    {ticket.showSeparator && (
                      <div className="ticket-people-badge" style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}></div>
                    )}
                  </div>
                  <div className="ticket-features-list">
                    {ticket.features.map((feature, idx) => (
                      <div className="ticket-feature" key={idx}>
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="M5 13l4 4L19 7" stroke={ticket.color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                  <a 
                    href="https://shop.amarefestival.com" 
                    className="ticket-buy-btn"
                    style={{ background: '#fff', color: '#000' }}
                  >
                    <Trans>BUY NOW</Trans>
                  </a>
                  <p className="ticket-fees-text"><Trans>*Price includes fees and taxes</Trans></p>
                </div>
              </div>
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
}

export default Tickets;